import React from "react";
import QuillEditor from "../../../../components/QuillEditor/QuillEditor";
import styles from "../../Introspekcije.module.css";

function VoditeljView({
  answers,
  introspectionQuestions,
  userId,
  isMentorRole,
}) {
  const questions = introspectionQuestions ?? "";
  return (
    <div>
      <div className={styles.quillContainer}>
        <QuillEditor
          answer={answers}
          introspectionQuestions={questions}
          userId={userId}
          isMentorRole={isMentorRole}
          isReadOnly={true}
          isContainerShowed={
            (isMentorRole && answers.length > 0) || !isMentorRole
          }
        />
      </div>
    </div>
  );
}

export default VoditeljView;
